(function() {
  'use strict';
  
  console.log('🚀 プログレスバースクリプト読み込み完了');
  
  function updateFreeShippingBar() {
    console.log('📊 updateFreeShippingBar 実行開始');
    
    const wrappers = document.querySelectorAll('.free-shipping-bar-wrapper');
    console.log('🔍 見つかったプログレスバー:', wrappers.length + '個');
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100;
        console.log('🛒 カート情報:', {
          合計金額: cartTotal + '円',
          商品数: cart.item_count + '個'
        });
        
        wrappers.forEach((wrapper, index) => {
          console.log(`\n--- プログレスバー ${index + 1} の処理開始 ---`);
          
          // カートページで空の場合
          if (wrapper.classList.contains('cart-page') && cart.item_count === 0) {
            wrapper.style.display = 'none';
            console.log('カートが空なので非表示');
            return;
          } else if (wrapper.classList.contains('cart-page')) {
            wrapper.style.display = 'block';
          }
          
          const message = wrapper.querySelector('.free-shipping-message');
          const progressBar = wrapper.querySelector('.free-shipping-progress-bar');
          const progressFill = wrapper.querySelector('.free-shipping-progress-fill');
          const indicator = wrapper.querySelector('.free-shipping-progress-indicator');
          
          if (!message || !progressFill || !progressBar) {
            console.log('❌ 必要な要素が見つかりません');
            return;
          }
          
          const threshold = parseInt(message.dataset.threshold) || 11000;
          const remaining = Math.max(0, threshold - cartTotal);
          const progress = Math.min(100, (cartTotal / threshold) * 100);
          
          console.log('計算結果:', {
            閾値: threshold + '円',
            残額: remaining + '円',
            進捗率: progress.toFixed(1) + '%'
          });
          
          // カートページのメッセージ更新
          if (wrapper.classList.contains('cart-page')) {
            const remainingSpan = wrapper.querySelector('.remaining-amount');
            if (remainingSpan) {
              remainingSpan.textContent = Math.round(remaining).toLocaleString('ja-JP');
              console.log('✅ カートページ: 残額表示を更新');
            }
          }
          
          // 商品ページのメッセージ更新
          if (wrapper.classList.contains('product-page')) {
            const defaultMessage = wrapper.querySelector('.default-message');
            const remainingMessage = wrapper.querySelector('.remaining-message');
            const remainingSpan = wrapper.querySelector('.remaining-amount');
            
            if (cart.item_count > 0 && remainingMessage && remainingSpan && defaultMessage) {
              // カートに商品がある場合は「あと◯◯円」表示
              defaultMessage.style.display = 'none';
              remainingMessage.style.display = 'inline';
              remainingSpan.textContent = Math.round(remaining).toLocaleString('ja-JP');
              console.log('✅ 商品ページ: 残額表示に切り替え');
            } else if (defaultMessage && remainingMessage) {
              // カートが空の場合はデフォルト表示
              defaultMessage.style.display = 'inline';
              remainingMessage.style.display = 'none';
              console.log('✅ 商品ページ: デフォルト表示');
            }
          }
          
          // プログレスバー更新
          progressFill.style.width = progress + '%';
          
          // インジケーター位置更新
          if (indicator) {
            indicator.style.left = progress + '%';
          }
          
          console.log(`--- プログレスバー ${index + 1} の処理完了 ---\n`);
        });
      })
      .catch(error => console.error('❌ カート情報の取得エラー:', error));
  }
  
  // 初回実行
  function init() {
    console.log('⏰ 初回実行（200ms後）');
    setTimeout(updateFreeShippingBar, 200);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // イベントリスナー
  document.addEventListener('cart:updated', () => {
    console.log('🔔 cart:updated イベント検知');
    updateFreeShippingBar();
  });
  
  // Fetch監視
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(response => {
      const url = arguments[0];
      if (typeof url === 'string' && url.includes('/cart/')) {
        console.log('🔔 カート関連のfetch検知:', url);
        setTimeout(updateFreeShippingBar, 300);
      }
      return response;
    });
  };
  
  // 定期更新
  setInterval(() => {
    console.log('⏰ 定期更新実行');
    updateFreeShippingBar();
  }, 5000);
})();
